import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table } from 'semantic-ui-react';

const CollaborationFeedItem = ({
  createdDate,
  message,
}) => (
  <Table.Row>
    <Table.Cell>
      { moment(createdDate).format('MMM DD [at] LT') }
    </Table.Cell>
    <Table.Cell>
      { message }
    </Table.Cell>
  </Table.Row>
);

CollaborationFeedItem.propTypes = {
  createdDate: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default CollaborationFeedItem;



/** WEBPACK FOOTER **
 ** ./src/components/collaboration-feed-item/index.js
 **/